import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import {
    Grid,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    TablePagination,
    TableFooter,
    Card,
    CardContent,
    Collapse,
    IconButton,
} from '@material-ui/core';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

import { selectAccountNotificationsData } from 'Console/data/applications/selectors';
import { updateNotification, fetchNotificationList } from 'Console/data/applications/actions';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
        padding: 24,
    },
    table: {
        width: '100%',
    },
    tableRow: {
        cursor: 'pointer',
    },
    tableWrapper: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.typography.pxToRem(20),
    },
    notificationUnreaded: {
        fontWeight: 'bold',
    },
    tableMessage: {
        width: '50%',
        overflow: 'hidden',
        height: theme.typography.pxToRem(17),
        lineHeight: 1.7,
    },
    expandedMessage: {
        paddingTop: theme.typography.pxToRem(16),
        paddingBottom: theme.typography.pxToRem(16),
    },
});

class TablePaginationActions extends Component {

    handleFirstPageButtonClick = (event) => {
        const { onChangePage } = this.props;
        onChangePage(event, 0);
    };

    handleBackButtonClick = (event) => {
        const { onChangePage, page } = this.props;
        onChangePage(event, page - 1);
    };

    handleNextButtonClick = (event) => {
        const { onChangePage, page } = this.props;
        onChangePage(event, page + 1);
    };

    handleLastPageButtonClick = (event) => {
        const { onChangePage, count, rowsPerPage } = this.props;
        onChangePage(
            event,
            Math.max(0, Math.ceil(count / rowsPerPage) - 1)
        );
    };

    render() {
        const { classes, count, page, rowsPerPage, theme } = this.props;

        return (
            <div className={classes.tableWrapper}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
                <IconButton
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })(TablePaginationActions);
